import { BehaviorSubject, Subject } from 'rxjs';

export class DataState<T>
{
    $data: BehaviorSubject<T[]> = new BehaviorSubject<T[]>([]);
    $loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    $interrupt: Subject<void> = new Subject<void>();
    $count: BehaviorSubject<number> = new BehaviorSubject<number>(0);
    private _data: T[];

    constructor(private compareKey: string = 'id') {
    }

    loading() {
        this.$loading.next(true);
        this.$interrupt.next();
    }

    set(data: T[]) {
        this._data = data;
        this.$data.next(this._data);
        this.$count.next(data.length);
        this.$loading.next(false);
    }

    update(data: T) {
        const index = this._data.findIndex((element) => element[this.compareKey] === data[this.compareKey]);
        if (index !== -1) {
            Object.assign(this._data[index], data);
        } else {
            this._data.push(data);
        }
        this.$data.next(this._data);
        this.$count.next(this._data.length);
        this.$loading.next(false);
    }

    remove(key: any) {
        const index = this._data.findIndex((element) => element[this.compareKey] === key);
        if (index !== -1) {
            this._data.splice(index, 1);
        }
        this.$data.next(this._data);
        this.$count.next(this._data.length);
        this.$loading.next(false);
    }
}
